import { useEffect, useRef, useState } from "react";
import { useScrollToTop } from "core/hooks/useScrollToTop";
import AppLayout from "core/layouts/AppLayout";
import BottomNavigation from "core/layouts/BottomNavigation";
import PageHeader from "core/components/Header/PageHeader";
import { _t } from "core/language";
import { useRecipe } from "modules/Ingredients/hooks/recipe";
import { useFormikCustom } from "core/hooks/useFormikCustom";
import { CInputControl } from "core/components/form-controls";
import { getFieldInputProps } from "core/utils/form";
import ItemSeach from "../components/Search/ItemSeach";
import { getYouTubeThumbnail } from "core/utils/helper";
import Icon from "core/assets/icons";
import EmptyData from "core/components/EmptyData";
import { useSearchRecipes } from "../hooks/recipe";
import InfiniteScroll from "react-infinite-scroll-component";
import useDebounce from "core/hooks/useDebounce";
import { SEARCH_AI_RECIPE_ERROR, SEARCH_AI_RECIPE_SUCCESS, SEARCH_RECIPE_SUCCESS } from "../store/types";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { route, RouterName } from "core/router";
import RecipeSearchItemLoading from "modules/Recipes/components/Search/Loading";

const SearchRecipesPage = () => {
  useScrollToTop()
  const { resetRecipes } = useRecipe()
  const navigate = useCustomNavigate();

  const { data, loading, fetchData, params, loadMore, resetSearch, type, requestSearchAi, loadingSearchAi } = useSearchRecipes();

  const [searchTerm, setSearchTerm] = useState<string | undefined>(params?.keyword || '');
  const [stateSearchAi, setStateSearchAi] = useState(false);
  const [stateSearchAiNotFound, setStateSearchAiNotFound] = useState(false);

  const formik = useFormikCustom({
    initialValues: {
      name: '',
    },
    onSubmit() {
      //
    },
  });

  // Debounce search term
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  
  useEffect(() => {
    if (debouncedSearchTerm) {
      const paramsSearch = params;
      paramsSearch.keyword = debouncedSearchTerm;
      fetchData(1, paramsSearch);
      setStateSearchAiNotFound(false)
    } 
  }, [debouncedSearchTerm]);

  useEffect(() => {
    
    if (params.keyword) {
      formik.setValues((pre) => ({
        ...pre,
        name: params.keyword,
      }))
    }
  }, [])


  useEffect(() => {
    if (!data.length && searchTerm && !loading && params?.keyword && type === SEARCH_RECIPE_SUCCESS) {
      const paramsSearchAi = params;
      paramsSearchAi.keyword = debouncedSearchTerm;
      console.log(searchTerm,debouncedSearchTerm,data,'type',type,'paramsSearchAi',params, paramsSearchAi)
      // return
      if (loadingSearchAi) {
        return
      }
      requestSearchAi(paramsSearchAi)
      setStateSearchAi(true)
    }

    if([SEARCH_AI_RECIPE_SUCCESS, SEARCH_AI_RECIPE_ERROR].includes(type)) {
      setStateSearchAi(false)
      setStateSearchAiNotFound(true)
    }

    if([SEARCH_RECIPE_SUCCESS].includes(type) && (!searchTerm || !debouncedSearchTerm)) {
      resetSearch()
    }

  }, [data, searchTerm, debouncedSearchTerm, loading, type, setStateSearchAi, loadingSearchAi])
  

  const formikRef = useRef(formik);
  useEffect(() => {
    formikRef.current = formik;
  }, [formik]);

  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (formik.values.name && formik.values.name.trim()) {
      setSearchTerm(formik.values.name);
    } else {
      resetSearch()
      setSearchTerm("");
    }
  }, [formik.values.name]);


  const handleGoBack = () => {
    resetSearch()
    navigate(route(RouterName.MAIN))
  }

 
  return (
    <AppLayout>
      <PageHeader
        title={_t('recipe.search.title')}
        sticky
        handleGoBack={handleGoBack}
      />
      <div className="relative w-full max-w-md mx-auto   p-4">
        <div className="relative">
          <CInputControl
            className=""
            maxLength={200}
            placeholder={_t('recipe.search.placeholder')}
            classNameIcon="!w-[18px] !h-[18px]"
            classNameInput={`!text-[14px] !pr-[26px] ${formik.values.name ? ' !border-[#FF6741]' : ''}`}
            {...getFieldInputProps(formik, 'name')}
          />
          {formik.values.name && (
          <img src={Icon.IconClean}
            alt=""
            className="absolute right-[9px] top-[11px]"
            onClick={() => {
              resetSearch()
              formik.setValues((pre) => ({
                ...pre,
                name: '',
              }))
            }}
          />)}
        </div>

        <InfiniteScroll
          dataLength={data.length}
          next={loadMore}
          hasMore={!!data.length}
          loader={null}
          className=""
          scrollThreshold={1}
        >
          {data.length > 0 && (
            <ul className=" w-full mt-2 bg-white  z-10">
              {data.map((item: any, index:number) => (
                <ItemSeach
                  key={index}
                  item={item}
                  image={item?.thumbnail || (item?.video_id && getYouTubeThumbnail(item.video_id)) || Icon.NoImage}
                  textSearch={debouncedSearchTerm}
                />
              ))}
            </ul>
          )}
        </InfiniteScroll>
      </div>

      {loading && !stateSearchAi ? (
           <div className="grid gap-x-2 p-4">
            {Array.from(Array(params?.page === 1 ? 10 : 4).keys()).map(
              (e: number) => <RecipeSearchItemLoading key={e} />
            )}
          </div>
        ) : null
      }

      <div className="">
        {(!stateSearchAi && !searchTerm && !loading && data.length == 0) ? <EmptyData
          classNameText="!text-[14px] !font-normal px-[5px]"
          message={_t('recipe.search.msg_default_recipe')}
          className="px-[15px]"
        /> : ''}
      </div>

      <div className="">
        {(stateSearchAi && data.length == 0) ? <EmptyData
          icon={Icon.IconSearching}
          classNameText="!text-[14px] !font-normal px-[5px]"
          message={_t('recipe.search.searching')}
          className="px-[15px]"
        /> : ''}
      </div>

      <div>
        {(searchTerm && !loading && data.length == 0 && stateSearchAiNotFound) ? <EmptyData
          icon={Icon.IconUnHappy}
          classNameText="!text-[14px] !font-normal"
          message={_t('recipe.search.not_found')}
          className="px-[15px]"
        /> : ''}
      </div>


      <BottomNavigation
        onNavigateChange={resetRecipes}
        activeIndex={2}
      />
    </AppLayout>
  );
};

export default SearchRecipesPage;
